import React from 'react';
import { ArrowUpRightIcon, LockIcon, RadioIcon } from 'lucide-react';
import { useIsLive } from '../hooks/useIsLive';
type LiveAccessButtonProps = {
  href: string;
  linkOpensAt: string;
  broadcastStart: string;
  linkAvailability: string;
  broadcastLabel: string;
};
export function LiveAccessButton({
  href,
  linkOpensAt,
  broadcastStart,
  linkAvailability,
  broadcastLabel
}: LiveAccessButtonProps) {
  const linkOpen = useIsLive(linkOpensAt);
  const onAir = useIsLive(broadcastStart);
  if (linkOpen && href) {
    return <a href={href} target="_blank" rel="noopener noreferrer" className="group flex h-full flex-col justify-between gap-6 rounded-2xl border-2 border-ink bg-white p-5 text-ink transition-[transform,background-color] duration-150 ease-out hover:-translate-y-0.5 hover:bg-[#fafafa] focus:outline-none focus-visible:ring-4 focus-visible:ring-cnt-cyan/60 active:translate-y-0 sm:p-6" data-id="element-9" data-mp="2j6qzcg9cjuvd">
        <div className="flex items-start justify-between" data-id="element-10" data-mp="xuzbsngw359q">
          <span className="flex h-11 w-11 items-center justify-center rounded-full bg-cnt-cyan text-white" data-id="element-11" data-mp="3isp4k92q5ggf">
            <RadioIcon className="h-5 w-5" aria-hidden="true" data-id="element-12" data-mp="3msfwig3zm2mj" />
          </span>
          <ArrowUpRightIcon className="h-6 w-6 text-ink/60 transition-transform duration-150 ease-out group-hover:-translate-y-0.5 group-hover:translate-x-0.5 group-hover:text-ink" aria-hidden="true" data-id="element-13" data-mp="38s54vauusk0b" />
        </div>
        <div className="text-left" data-id="element-14" data-mp="2z1k8lu2njrkk">
          <span className="block whitespace-nowrap text-xl font-semibold tracking-tight sm:text-2xl" data-id="element-15" data-mp="33ud8o4n6ebqb">
            Accéder au live
          </span>
          {onAir ? <span className="mt-2 inline-flex items-center gap-2 rounded-full bg-cnt-red/10 px-3 py-1 text-sm font-medium text-[#b3202f]" data-id="element-16" data-mp="2v1tat6epkb6j">
              <span className="relative flex h-2 w-2" aria-hidden="true" data-id="element-17" data-mp="2g5keacm7cbxt">
                <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-cnt-red opacity-60 motion-reduce:hidden" data-id="element-18" data-mp="2l45a7zuf89gg" />
                <span className="relative inline-flex h-2 w-2 rounded-full bg-cnt-red" data-id="element-19" data-mp="220jyy90off4p" />
              </span>
              En direct sur YouTube
            </span> : <span className="mt-2 inline-flex items-center gap-2 rounded-full bg-cnt-cyan/15 px-3 py-1 text-sm font-medium text-[#0b6a78]" data-id="element-20" data-mp="1sa8v0mgzt5xt">
              <span className="h-1.5 w-1.5 rounded-full bg-cnt-cyan" aria-hidden="true" data-id="element-21" data-mp="1n802fr8185w8" />
              {broadcastLabel}
            </span>}
        </div>
      </a>;
  }
  return <button type="button" disabled aria-disabled="true" aria-describedby="live-availability" className="flex h-full w-full cursor-not-allowed flex-col justify-between gap-6 rounded-2xl border-2 border-dashed border-black/15 bg-white/50 p-5 text-left text-ink sm:p-6" data-id="element-22" data-mp="2fwp35p56e97g">
      <div className="flex w-full items-start justify-between" data-id="element-23" data-mp="ziffkx8rcoho">
        <span className="flex h-11 w-11 items-center justify-center rounded-full bg-black/[0.06] text-muted" data-id="element-24" data-mp="uknou6jun8f2">
          <RadioIcon className="h-5 w-5" aria-hidden="true" data-id="element-25" data-mp="36adftk710mq5" />
        </span>
        <LockIcon className="h-5 w-5 text-muted" aria-hidden="true" data-id="element-26" data-mp="3b8x25lpj80j1" />
      </div>
      <div id="live-availability" data-id="element-27" data-mp="3g6gcwbn0tv68">
        <span className="block whitespace-nowrap text-xl font-semibold tracking-tight text-ink/45 sm:text-2xl" data-id="element-28" data-mp="3g5dp4ckzw8uj">
          Accéder au live
        </span>
        <span className="mt-2 inline-flex items-center gap-2 whitespace-nowrap rounded-full bg-cnt-yellow/20 px-3 py-1 text-sm font-medium text-[#8a5a00]" data-id="element-29" data-mp="3px1kgokoaa1a">
          <span className="h-1.5 w-1.5 rounded-full bg-cnt-yellow" aria-hidden="true" data-id="element-30" data-mp="3twjvmsmoz6qx" />
          {linkAvailability}
        </span>
        <span className="mt-1.5 block text-sm text-muted" data-id="element-31" data-mp="7r50tgpia486">{broadcastLabel}</span>
      </div>
    </button>;
}